module.exports = __webpack_public_path__ + "img/hourglass-end-solid.a2b3a0dc.svg";